/* unplugin-vue-components disabled */import script from "./Tab3Dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./Tab3Dialog.vue?vue&type=script&setup=true&lang=js"

import "./Tab3Dialog.vue?vue&type=style&index=0&id=2fedc4ae&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fedc4ae"]])

export default __exports__